import { Connection, Schema } from '@wix/cms-viewer-core'
import { FieldType } from '@wix/wix-data-schema-types'

export const adaptBuilderConnection = (builderConnection, role, schema) => {
  const properties = Object.fromEntries(
    Object.entries(builderConnection.byItem).map(
      ([propName, { config: { parentDataType, dataType, fieldKey, format } }]) =>
        [
          role === 'textRole' && propName === 'richText'
            ? Schema.getFieldType(schema, fieldKey) === FieldType.richText
              ? 'html' : 'text'
            : parentDataType === 'a11y'
              ? 'accessibility.ariaLabel'
              : propName,
          Connection.makePropertyConnectionToField({
            fieldKey,
            outputType:
              dataType === 'text'
              || (role === 'textRole' && propName === 'richText')
              || parentDataType
                ? 'text' : 'unknown',
            format,
          }),
        ],
    ),
  )

  const { link: { config: { data } } = { config: {} } } = builderConnection.byItem

  return Connection.make({ properties, data })
}
